export enum EmployerSubmissionTypeEnum {
  AddNewEmployer = 1,
  UpdateAddress = 2,
  UpdateContacts = 3,
  UpdateEmploymentStatus = 4
}
